module.exports = __webpack_public_path__ + "img/white-bottom-right.b88ef534.png";